import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ManageMembers from './ManageMembers'
//import _ from 'lodash'

class MembersComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.members.team) {
      return <div><ManageMembers team={this.props.members.team} members={this.props.members.members} nonmembers={this.props.members.nonmembers}></ManageMembers></div>
    }
    return <div></div>
  }
}

MembersComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  members: PropTypes.object.isRequired,
}

export default MembersComponent
